export enum DocumentExportType {
  MEETING_SUMMARY = 'meetingSummary',
  DOCUMENT_SUMMARY = 'documentSummary',
  FORM = 'form',
  MEETING_PREP = 'meetingPrep',
}
